/* @flow */

import * as React from 'react';
import { identity } from 'lodash/fp';

type Props = {
  children: React.ChildrenArray<React.Node>,
  reverse: boolean,
};

function ReversibleFragment({
  children,
  reverse,
}: Props) {
  if (reverse) {
    return React.Children.toArray(children).reverse().map(identity);
  }

  return children;
}

export default ReversibleFragment;
